"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedA = exports.ThemedH6 = exports.ThemedH5 = exports.ThemedH4 = exports.ThemedH3 = exports.ThemedH2 = exports.ThemedH1 = exports.ThemedParagraph = exports.ThemedSpan = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const setFont = (props) => {
    const { theme, font } = props;
    const fontAttr = theme.typography[font !== null && font !== void 0 ? font : 'base'];
    if (font === undefined) {
        const { fontSize, lineHeight } = fontAttr, attributesExcludingSizes = __rest(fontAttr, ["fontSize", "lineHeight"]);
        return (0, styled_components_1.css)(attributesExcludingSizes);
    }
    return (0, styled_components_1.css)(fontAttr);
};
const setSpacing = (props) => {
    const { theme, spacing } = props;
    if (spacing) {
        return (0, styled_components_1.css)({ lineHeight: theme.spacings[spacing], whiteSpace: 'pre-wrap' });
    }
    return (0, styled_components_1.css)({});
};
const setColor = (props) => {
    const { theme, color = 'base' } = props;
    const fontColor = theme.palettes.font[color];
    return (0, styled_components_1.css)({ color: fontColor });
};
const setHoverColor = (props) => {
    const { theme, hoverColor = 'linkHover' } = props;
    const color = theme.palettes.font[hoverColor];
    return (0, styled_components_1.css)({ color });
};
const setHoverUnderline = (props) => {
    const { underlineOnHover = true } = props;
    return (0, styled_components_1.css)({ textDecoration: underlineOnHover ? 'underline' : 'none' });
};
const getBoldStyle = (props) => {
    const { bold } = props;
    if (bold === undefined) {
        return {};
    }
    return { fontWeight: bold ? 700 : 400 };
};
const getItalicStyle = (props) => {
    const { italic } = props;
    return italic ? { fontStyle: 'italic' } : {};
};
const setEmphasis = (props) => {
    return (0, styled_components_1.css)(Object.assign(Object.assign({}, getBoldStyle(props)), getItalicStyle(props)));
};
exports.ThemedSpan = styled_components_1.default.span `
  ${setFont};
  ${setColor};
  ${setEmphasis};
  ${setSpacing};
`;
exports.ThemedParagraph = styled_components_1.default.p `
  ${setFont};
  ${setColor};
  ${setEmphasis};
  ${setSpacing};
`;
exports.ThemedH1 = styled_components_1.default.h1 `
  ${setFont};
  ${setColor};
  ${setEmphasis};
`;
exports.ThemedH2 = styled_components_1.default.h2 `
  ${setFont};
  ${setColor};
  ${setEmphasis};
`;
exports.ThemedH3 = styled_components_1.default.h3 `
  ${setFont};
  ${setColor};
  ${setEmphasis};
`;
exports.ThemedH4 = styled_components_1.default.h4 `
  ${setFont};
  ${setColor};
  ${setEmphasis};
`;
exports.ThemedH5 = styled_components_1.default.h5 `
  ${setFont};
  ${setColor};
  ${setEmphasis};
`;
exports.ThemedH6 = styled_components_1.default.h6 `
  ${setFont};
  ${setColor};
  ${setEmphasis};
`;
exports.ThemedA = styled_components_1.default.a `
  ${setFont};
  ${setColor};
  ${setEmphasis};
  &:hover {
    ${setHoverColor};
    ${setHoverUnderline};
  }
`;
